import React from 'react';
import ReactionAvatarStack from './ReactionAvatarStack';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const THREAD_FRAGMENT = gql(`
  fragment ReactionThreadMinimized_thread on PublicThreadFields {
    id
    reactions {
      id
      ...ReactionAvatarStack_reaction
    }
  }
`);

interface ReactionThreadMinimizedProps {
  thread: DocumentType<typeof THREAD_FRAGMENT>;
}

const ReactionThreadMinimized = ({ thread }: ReactionThreadMinimizedProps) => {
  const firstReaction = thread.reactions.at(0);

  return firstReaction ? (
    <ReactionAvatarStack reactions={[firstReaction]} ring={false} />
  ) : null;
};

export default ReactionThreadMinimized;
